import React, {Fragment} from 'react'
import styles from './IndexPage.scss'
import appStyles from '../App/appStyles.scss'
import { Route, IndexRoute, Link } from 'react-router'
import {ReportListContainer} from './ReportList'
import {AdminPageContainer} from '../AdminPage'
import {Button} from 'common/Button'
import cx from 'classnames'
import {DraftListContainer} from './DraftList'
import {connect} from 'react-redux'
import {Gleam} from 'common/Gleam'
import Helmet from 'react-helmet'
import {TwoTierNav, NavbarLink, NavbarIndexLink} from 'common/TwoTierNav'
import {GlobalFooter} from 'common/GlobalFooter'
import {ShowcaseContainer as RolloutShowcase} from '../RolloutContest/Showcase'
import {VoteAdminContainer} from '../RolloutContest/VoteAdmin'
// TODO: measure impact of code-splitting on IndexPage and ReportViewer load
// time and bandwidth usage.

export const rrSubnav = ({currentUser, draftCount}) => <Fragment>
  <div>
    <NavbarIndexLink to='/ride_reports'>Featured Reports</NavbarIndexLink>
    <NavbarLink to='/ride_reports/rollout2017'>Rollout Contest Winners</NavbarLink>
    <NavbarLink to='/ride_reports/recent'>Recent</NavbarLink>
    {currentUser.id && <NavbarLink to='/ride_reports/friends'>From Friends</NavbarLink>}
    {currentUser.id && <NavbarLink to='/ride_reports/following'>Following</NavbarLink>}
  </div>
  <div>
    {currentUser.id && <NavbarLink to={`/ride_reports/user/${currentUser.id}/`}>Your Reports</NavbarLink>}
    {currentUser.accountLevel === 11 && <NavbarLink to='/ride_reports/admin'>Admin</NavbarLink>}
    {currentUser.id && <NavbarLink to='/ride_reports/drafts'>
      Drafts {draftCount > 0 && <Gleam>{draftCount}</Gleam>}
    </NavbarLink>}
    {currentUser.id && <Link to='/ride_reports/new' className={styles.bold}><Button type='success'>+ new report</Button></Link>}
  </div>
</Fragment>

export const IndexPage = ({children, currentUser, draftCount}) => (
  <div className={cx(appStyles.base, styles.wrapper)}>
    <TwoTierNav secondaryNav={rrSubnav({currentUser, draftCount})} />
    <div className={styles.IndexPage}>
      {children}
    </div>
    <GlobalFooter className={styles.footer} />
  </div>
)

const Featured = ({state, rolloutParticipant}) => (
  <ReportListContainer endpoint='featured' title='Get Inspired'>
    <Helmet title='Ride Reports · Featured' />
    <div className={styles.featuredCTA}>
      <div className={styles.left}>
        <p>For the launch of our Ride Reports feature in the spring of 2017, we
        challenged our users to go on rides that challenged and inspired them,
        then share those ride in the form of a Ride Report.</p>
        <p>With the help of the community, we've selected 10 of the best contest
        submissions. Read them, and get started planning your next adventure</p>
      </div>
      <div className={styles.right}>
        <Link to='/ride_reports/rollout2017'><Button className={styles.ctaButton}>View Winners</Button></Link>
      </div>
    </div>
  </ReportListContainer>
)

const mapStateToProps = (state) => ({
  currentUser: state.currentUser,
  draftCount: state.editPage.draftList.size,
  rolloutParticipant: window.rwgps.config.rolloutParticipant
})

export const FeaturedContainer = connect(
  mapStateToProps,
  null
)(Featured)

export const IndexPageContainer = connect(
  mapStateToProps,
  null
)(IndexPage)

const Recent = () => (<ReportListContainer endpoint='recent' title='Latest Reports'><Helmet title='Ride Reports · Recent' /></ReportListContainer>)

const Friends = () => (<ReportListContainer endpoint='friends' title="Friends' Reports"><Helmet title='Ride Reports · Friends' /></ReportListContainer>)

const Following = () => (<ReportListContainer endpoint='following' title='Reports from Users You Follow'><Helmet title='Ride Reports · Following' /></ReportListContainer>)

const ContestEntries = () => (<ReportListContainer endpoint='contest_entries' title='Latest Contest Entries'><Helmet title='Ride Reports · Contest Entries' /></ReportListContainer>)

const UserReports = ({params: {userId}}) => (<ReportListContainer endpoint={`/user/${userId}`} />) // not applying a title here because we don't know the user's name. This component is due for a refactor.

const SecretFinalistCandidatePage = () => (
  <ReportListContainer endpoint='inquisitive_marauding_wombat' title='Finalist Candidate List'>
    <p>This is our list of the cream of the crop from all 8 weeks that the contest has been running</p>
    <p>Please <strong>do not</strong> share this URL, it's super-secret for your eyes only!</p>
  </ReportListContainer>)

const Drafts = (props) => (<DraftListContainer {...props} />)

export const IndexRoutes = (
  <Route component={IndexPageContainer}>
    <IndexRoute component={FeaturedContainer} />
    <Route path='recent' component={Recent} />
    <Route path='friends' component={Friends} />
    <Route path='following' component={Following} />
    <Route path='contest_entries' component={ContestEntries} />
    <Route path='drafts' component={Drafts} />
    <Route path='user/:userId' component={UserReports} />
    <Route path='admin' component={AdminPageContainer} />
    <Route path='rollout2017' component={RolloutShowcase} />
    <Route path='vote_admin' component={VoteAdminContainer} />
    <Route path='inquisitive_marauding_wombat' component={SecretFinalistCandidatePage} />
  </Route>
)
